import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button, Card, Descriptions, Flex, Typography } from 'antd';

import dayjs from 'dayjs';

import axios from '../../axios';

import { formatDateDifference } from '../../helpers/date';
import { hasPermission } from '../../helpers/user';

import { DATE_FORMAT } from '../../constants/common';
import { NOTIFICATION_STATUS } from '../../constants/notifications';
import { PERMISSIONS } from '../../constants/permissions';

import { fetchNotification } from '../../redux/actions/notifications';

import AppTag from '../../components/AppTag';
import PrevNextButtons from '../../components/PrevNextButtons';
import Priority from '../../components/PriorityTag';
import AppList from '../../components/ui/AppList';

import AppBreadcrumb from '../ui-components/AppBreadcrumb';
import AppDropdown from '../ui-components/AppDropdown';

const { Title } = Typography;

class NotificationPage extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      actions: [],
      activeTab: '1',
      add_modal: false,
      delete_modal: false,
      livestock_opts: [],
      new_label: {
        color: '',
        livestock: [],
        name: '',
        rules: []
      },
      notificationStatus: {
        snoozable: 'New',
        snoozed: 'Snoozed',
        unsnoozable: 'Cleared'
      },
      notification: {
        date: '',
        description: '',
        gateways: [],
        id: null,
        name: '',
        priority: '',
        rule: {},
        tags: [],
        type: ''
      },
      query: '',
      rules_opts: [],
      selected_labels: [],
      selected_livestock: [],
      selected_rules: []
    };

    // this.getLivestock = this.getLivestock.bind(this);
    this.getNotification = this.getNotification.bind(this);
    this.getRules = this.getRules.bind(this);
    this.initActions = this.initActions.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.getCurrentNotification = this.props.getCurrentNotification.bind(this);
  }

  async componentDidMount() {
    // await this.getLivestock();
    await this.getNotification();

    let that = this;
    this.setState(prev => ({
      ...prev,
      notification: {
        ...this.props.notification,
        age: formatDateDifference(that.props.notification.created_at, { includeHours: true, includeMinutes: true })
      }
    }));

    this.initActions(this.props.notification);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.notification?.id !== this.props?.notification?.id) {
      this.setState(prev => ({ ...prev, notification: this.props.notification }));
    }
  }

  initActions(notification) {
    const availableActions = [];

    if (hasPermission([PERMISSIONS.NOTIFICATIONS.UPDATE_OWN], this.props.userPermissions)) {
      availableActions.push(
        {
          label: (
            <Button
              color="default"
              size="small"
              variant="link"
              disabled={this.state.notificationStatus[notification.status] === 'Cleared'}
              onClick={() => this.clearNotification()}>
              Clear notification
            </Button>
          )
        },
        {
          label: (
            <Button
              color="default"
              size="small"
              variant="link"
              disabled={this.state.notificationStatus[notification.status] === 'Cleared'}
              onClick={() => this.snoozeNotification()}>
              Snooze notification
            </Button>
          )
        }
      );
    }

    this.setState({ actions: availableActions });
  }

  onChange = (value, field) => {
    this.setState(state => ({ ...state, [field]: value }));
  };

  async getNotification() {
    const notification = await this.getCurrentNotification({
      id: this.props.match.params.id,
      params: { query: this.state.query }
    });

    this.setState(prev => ({ ...prev, notification: notification.payload }));
    this.initActions(notification.payload);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
  }

  toggleModal(modal) {
    this.setState(state => ({ ...state, [modal]: !state[modal] }));
  }

  async getRules() {
    const response = await axios.get('rules');

    this.setState({ rules_opts: response.data });
  }

  // async getLivestock() {
  //   const response = await axios.get('animals');
  //
  //   this.setState({ livestock_opts: response.data });
  // }

  async snoozeNotification() {
    await axios.put('notifications/' + this.props.match.params.id + '/snooze');
    await this.getNotification();
  }

  async clearNotification() {
    const id = this.props.match.params.id;
    await axios.put('notifications/' + id + '/clear');

    await this.getNotification();
  }

  render() {
    if (this.state.notification.id === null) return null;

    const data = [
      {
        label: 'Notification ID',
        value: this.state.notification.identifier,
        isVisible: true
      },
      {
        label: 'Notification Message',
        value: this.state.notification.message,
        isVisible: true
      },
      {
        label: 'Notification Priority',
        value: <Priority priority={this.state.notification.priority} />,
        isVisible: true
      },
      {
        label: 'Notification Status',
        value: <AppTag style={{ background: 'gray' }}>{NOTIFICATION_STATUS[this.state.notification.status]}</AppTag>,
        isVisible: true
      },
      {
        label: 'Notification Type',
        value: this.state.notification.type,
        isVisible: true
      },
      {
        label: 'Notification Trigger Time',
        value: dayjs(this.state.notification.created_at).format(DATE_FORMAT.DATETIME),
        isVisible: true
      },
      {
        label: 'Notification Age',
        value: this.state.notification.age,
        isVisible: true
      },
      {
        label: 'User Actions',
        value: (
          <>
            Snoozed on : &nbsp;
            {this.state.notification.snooze_history &&
              this.state.notification.snooze_history
                .map(x => dayjs(x.created_at).format(DATE_FORMAT.DATETIME))
                .join(', ')}
            <br></br>
            Cleared on : &nbsp;
            {this.state.notification.clear_history &&
              this.state.notification.clear_history
                .map(x => dayjs(x.created_at).format(DATE_FORMAT.DATETIME))
                .join(', ')}
          </>
        ),
        isVisible: true
      },
      {
        label: 'Rule ID',
        value: (
          <Link to={`/rule/${this.state.notification?.rule?.id}`}>{this.state.notification?.rule?.identifier}</Link>
        ),
        isVisible: !!this.state.notification?.rule?.id
      },
      {
        label: 'Livestock Count',
        value: this.state.notification?.livestocks?.length ?? 0,
        isVisible: true
      },
      {
        label: 'Kraal Tag ID',
        value: (
          <>
            {this.state.notification.tags &&
              this.state.notification.tags.length > 0 &&
              this.state.notification.type !== 'tag' &&
              this.state.notification.tags.map(x => x.diagri_id).join(', ')}
            {this.state.notification.tags &&
              this.state.notification.tags.length > 0 &&
              this.state.notification.type === 'tag' &&
              this.state.notification.tags
                .map(j => (
                  <Link key={j.id} to={`/tag/${j.id}`}>
                    {j.diagri_id}
                  </Link>
                ))
                .reduce((prev, curr) => [prev, ', ', curr])}
          </>
        ),
        isVisible: true
      },
      {
        label: 'Livestock IDs',
        value: (
          <>
            {this.state.notification.livestocks &&
              this.state.notification.livestocks.length > 0 &&
              this.state.notification.livestocks
                .map(x => (
                  <Link
                    key={x.id}
                    to={this.state.notification.type === 'geolocation' ? `/tracking/${x.id}` : `/animals/${x.id}`}>
                    {x.identifier}
                  </Link>
                ))
                .reduce((prev, curr) => [prev, ', ', curr])}
          </>
        ),
        isVisible: true
      },
      {
        label: 'Mgmt Tag ID',
        value: (
          <>
            {this.state.notification.livestocks &&
              this.state.notification.livestocks.length > 0 &&
              this.state.notification.livestocks.map(x => x.management_tag_id).join(', ')}
          </>
        ),
        isVisible: true
      },
      {
        label: 'Gateway ID',
        value: (
          <>
            {this.state.notification.gateways &&
              this.state.notification.gateways.length > 0 &&
              this.state.notification.gateways
                .map(i => (
                  <Link key={i.id} to={`/gateway/${i.id}`}>
                    {i.identifier}
                  </Link>
                ))
                .reduce((prev, curr) => [prev, ', ', curr])}
          </>
        ),
        isVisible: this.state.notification?.gateways?.length > 0
      }
    ];

    const breadcrumbItems = [
      {
        title: <Link to={`/notifications`}>List of Notifications</Link>
      },
      {
        title: `Notification ${this.state.notification.identifier}`
      }
    ];

    return (
      <div key={this.props.match.params.id}>
        <Flex gap="small" vertical={false} justify="space-between" wrap>
          <Flex vertical={true}>
            <Title level={4}>Notification «{this.state.notification.identifier}»</Title>

            <AppBreadcrumb items={breadcrumbItems} />
          </Flex>
          <Flex gap="small">
            <AppDropdown label="Actions" items={this.state.actions} />

            <PrevNextButtons
              nextId={this.props.notification?.next_id}
              prevId={this.props.notification?.prev_id}
              handlePrev={() => this.props.history.push(`/notification/${this.props.notification?.prev_id}`)}
              handleNext={() => this.props.history.push(`/notification/${this.props.notification?.next_id}`)}
            />
          </Flex>
        </Flex>

        <Card title={`Notification «${this.state.notification.identifier || ''}» details`}>
          <AppList>
            {data?.map(d => (
              <>
                {d.isVisible && (
                  <Descriptions.Item className="capitalize" key={d.label} label={d.label}>
                    {d.value}
                  </Descriptions.Item>
                )}
              </>
            ))}
          </AppList>
        </Card>
      </div>
    );
  }
}

export default connect(
  state => ({
    notification: state.notifications.notification,
    user: state.user.user,
    userPermissions: state.user.permissions
  }),
  dispatch => ({
    // setNotificationList: data => {
    //   dispatch(setNotificationList(data));
    // },
    getCurrentNotification: ({ id, params }) => dispatch(fetchNotification({ id, params }))
  })
)(NotificationPage);
